<template>
	<div v-if="orderEditAddress" class="wwim-modal">
		<form action="javascript:;">
			<p class="wm-head">修改地址<a href="javascript:;" class="close icon icon-close" @click="$store.commit('changeOrderEditAddress', '')"></a></p>
			<div class="wm-field">
				<div class="field-list">
					<span>收件人：</span>
					<input type="text" name="receiverName" v-model="orderEditAddress.receiver_name" value="">
				</div>
				<div class="field-list">
					<span>地区：</span>
					<regionTree v-model="regionArr"></regionTree>
				</div>
				<div class="field-list">
					<span>地址：</span>
					<input type="text" name="receiverAddress" v-model="orderEditAddress.receiver_address" value="">
				</div>
				<div class="field-list">
					<span>邮编：</span>
					<input type="text" name="receiverZip" v-model="orderEditAddress.receiver_zip" value="">
				</div>
				<div class="field-list">
					<span>电话：</span>
					<input type="text" name="receiverPhone" v-model="orderEditAddress.receiver_phone" value="">
				</div>
				<div class="field-list">
					<span>手机：</span>
					<input type="text" name="receiverMobile" v-model="orderEditAddress.receiver_mobile" value="">
				</div>
			</div>
			<p class="wm-btnbox">
				<input type="submit" @click="submitEdit" value="确定">
			</p>
		</form>
	</div>
</template>

<script>
import regionTree from '../../components/regionTree.vue'
export default {
	name: 'orderEditAddress',
	data () {
		return {
			regionArr: []
		}
	},
	components: {
		'regionTree': regionTree
	},
	computed: {
		orderEditAddress () {
			return this.$store.state.orderEditAddress;
		},
		currentConversation () {
			return this.$store.state.currentConversation;
		}
	},
	watch: {
		orderEditAddress: {
			deep: true,
			handler (now) {
				if (!now) return;
				this.regionArr[0] = now.receiver_state.replace(/省/g,'');
				this.regionArr[1] = now.receiver_city;
				this.regionArr[2] = now.receiver_district;
			}
		}
	},
	methods: {
		// 提交修改
		submitEdit () {
			var self = this,
				kehuId = self.currentConversation.other.kehuId,
				data = {
					tid: self.orderEditAddress.tid,
					shopId: self.$store.state.currentShop.id,
					receiverName: self.orderEditAddress.receiver_name,
					receiverState: self.regionArr[0] || '',
					receiverCity: self.regionArr[1] || '',
					receiverDistrict: self.regionArr[2] || '',
					receiverAddress: self.orderEditAddress.receiver_address,
					receiverZip: self.orderEditAddress.receiver_zip,
					receiverPhone: self.orderEditAddress.receiver_phone || '',
					receiverMobile: self.orderEditAddress.receiver_mobile

				};

			self.$axios.post(API_ROOT.baseUrl + '/api/wwim/changeAddress', data).then(result => {
				if (result.code != 200) {
					alert('修改地址失败');
				} else {
					TJ_DB.del(TJ_DB.ORDER_Table, "'newKey' == " + kehuId + '-' + data.shopId);
					self.$store.commit('changeOrderEditAddress', '');
					var orderData = self.$store.state.orderData;
					for (var i = 0; i < orderData.length; i++) {
						if (orderData[i].tid != data.tid) continue;
						orderData[i].receiver_name = data.receiverName;
						orderData[i].receiver_state = data.receiverState;
						orderData[i].receiver_city = data.receiverCity;
						orderData[i].receiver_district = data.receiverDistrict;
						orderData[i].receiver_address = data.receiverAddress;
						orderData[i].receiver_zip = data.receiverZip;
						orderData[i].receiver_phone = data.receiverPhone;
						orderData[i].receiver_mobile = data.receiverMobile;
						self.$store.commit('changeOrderData', orderData);
						break;
					}
				}
			}, response => {
				alert('修改地址失败');
			})
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/pages/aside/orderEditAddress.vue